import * as React from 'react';
import { Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import * as TFF from '@tff/types/TFF';
import { useIntl } from 'react-intl';
import TFFTypography from '../../styled-components/TFFTypography';
import { useBookingContext } from '../../hooks/use-booking-context';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    seatsPriceWrapper: {
      display: 'flex',
      justifyContent: 'flex-end',
      backgroundColor: '#E2F3FE',
      alignItems: 'center',
      padding: '5px 20px',
      borderRadius: '0 0 8px 8px',
    },
    priceWrapper: {
      display: 'flex',
      gap: '8px',
    },
    seatsWrapper: {
      display: 'flex',
      alignItems: 'center',
      gap: '8px',
    },
    tffSeats: {
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'row',
      marginLeft: '32px',
      gap: '8px',
    },
  }),
);

interface FlightSeatsAndPriceProps {
  ancillaries: TFF.Ancillary[];
  journey: TFF.Journey;
  orderDetails: TFF.OrderDetails;
  bookingSource: string;
}

const FlightSeatsAndPrice: React.FC<FlightSeatsAndPriceProps> = ({
  ancillaries,
  journey,
  bookingSource,
  orderDetails,
}) => {
  const classes = useStyles();
  const intl = useIntl();
  const { costFormatter } = useBookingContext();

  const fares: TFF.Fare[] | undefined = orderDetails?.Fares ? Object.values<TFF.Fare>(orderDetails.Fares) : [];

  const journeyFares: TFF.FareProduct[] = [];

  fares.forEach(f => {
    f?.FareProducts?.forEach(fp => {
      if (fp.JourneyOnd === journey.Ond) journeyFares.push(fp);
    });
  });

  const renderFlightPrice = () => {
    if (journeyFares && bookingSource === 'TUI-NSK') {
      let totalPrice = 0;
      journeyFares.forEach(j => {
        totalPrice += j?.BaseAmount as number;
      });
      return (
        <div className={classes.priceWrapper}>
          <TFFTypography
            text={intl.formatMessage({ id: 'cancel.flightPrice' })}
            variant="lead"
            modifier="uppercase"
            fontWeight="bold"
          />
          <TFFTypography
            text={costFormatter.format(+totalPrice)}
            variant="lead"
            modifier="uppercase"
            fontWeight="bold"
          />
        </div>
      );
    }
    return <></>;
  };

  return <div className={classes.seatsPriceWrapper}>{renderFlightPrice()}</div>;
};

export default FlightSeatsAndPrice;
